module.exports = __webpack_public_path__ + "static/media/status.1d288336.png";